// extracted by mini-css-extract-plugin
module.exports = {"header":"MainHeader_header__k5Wsz"};